import './compare-terms.scss';

import React from 'react';

import Layout from 'components/layout/Layout';
import CompareTermsVisualization from 'components/compare-terms/CompareTermsVisualization';
import VisualToolLinks from 'components/VisualToolLinks';

const CompareTermsPage: React.FC = () => {
  return (
    <Layout>
      <div className="CompareTermsPage-intro">
        <h1>Identify Related Skills Across Frameworks</h1>
        <p className="emphasis">
          Frameworks label skills very differently. It can be difficult to
          figure out where inside a framework the skill you are interested in
          lives – especially if it is labeled or grouped under an unfamiliar
          name.
        </p>
        <p className="emphasis">
          Use the sunburst diagram below to see where a particular skill appears
          across frameworks. Click on a skill in the sunburst or select from a
          list of 100+ common skills to highlight related skills across
          frameworks.
        </p>
      </div>

      <CompareTermsVisualization />

      <VisualToolLinks excludeVisualToolLink="terms" />
    </Layout>
  );
};

export default CompareTermsPage;
